// extracted by mini-css-extract-plugin
export default {"customScrollbar":"PatientProfile_customScrollbar__cTqiP","hideScrollbar":"PatientProfile_hideScrollbar__XIuMs","container":"PatientProfile_container__jBdf2"};